// Cookielös besöksstatistik för den publika sajten. Inga cookies och ingen
// storage – enda undantaget är 'bd_notrack', som besökaren själv kan sätta på
// /cookies (och ägaren i adminpanelen). Global Privacy Control respekteras.
const ENDPOINT = '/api/t';
const NOTRACK_KEY = 'bd_notrack';
const ADS_CLICK_PARAMS = ['gclid', 'gbraid', 'wbraid'];
// Servern ignorerar body över 2048 byte, så långa värden kortas redan här
const MAX_PATH_LENGTH = 200;
const MAX_REF_LENGTH = 500;
const MAX_UTM_LENGTH = 64;

// Landningskontexten lever bara i minnet under sidans livstid
let landing = null;
let lastPath = null;

export function isExcludedPath(pathname) {
  return typeof pathname !== 'string' || pathname.startsWith('/portal') || pathname.startsWith('/admin');
}

// Servern sparar bara värdnamnet, så query och hash behöver aldrig lämna webbläsaren
export function cleanReferrer(referrer) {
  if (typeof referrer !== 'string') return '';
  return referrer.split(/[?#]/)[0].slice(0, MAX_REF_LENGTH);
}

export function readLandingContext({ pathname, search, referrer }) {
  const params = new URLSearchParams(search || '');
  const utmValue = (name) => (params.get(`utm_${name}`) || '').trim().slice(0, MAX_UTM_LENGTH);

  return {
    landingPath: String(pathname || '/').slice(0, MAX_PATH_LENGTH),
    ref: cleanReferrer(referrer),
    utm: { source: utmValue('source'), medium: utmValue('medium'), campaign: utmValue('campaign') },
    // Bara om ett klick-ID finns, själva värdet skickas aldrig
    ads: ADS_CLICK_PARAMS.some((name) => params.has(name)),
  };
}

export function isTrackingDisabled() {
  try {
    return localStorage.getItem(NOTRACK_KEY) === '1';
  } catch {
    return false;
  }
}

// Returnerar läget som faktiskt gäller, eftersom localStorage kan vara blockerat
export function setTrackingDisabled(disabled) {
  try {
    if (disabled) {
      localStorage.setItem(NOTRACK_KEY, '1');
    } else {
      localStorage.removeItem(NOTRACK_KEY);
    }
  } catch { /* ignore */ }
  return isTrackingDisabled();
}

function canTrack(pathname) {
  if (typeof window === 'undefined' || window.__PRERENDER__) return false;
  if (typeof navigator !== 'undefined' && navigator.webdriver) return false;
  if (typeof navigator !== 'undefined' && navigator.globalPrivacyControl === true) return false;
  return !isExcludedPath(pathname) && !isTrackingDisabled();
}

function currentLandingContext() {
  return readLandingContext({
    pathname: window.location.pathname,
    search: window.location.search,
    referrer: document.referrer,
  });
}

export function trackPageview(pathname) {
  // StrictMode kör effekter två gånger och hash-länkar byter inte sida. Även
  // portalsidor uppdaterar lastPath, så att en återgång till samma publika sida
  // räknas som en ny sidvisning.
  if (pathname === lastPath) return;
  lastPath = pathname;
  if (!canTrack(pathname)) return;

  const isLanding = landing === null;
  if (isLanding) landing = currentLandingContext();

  send({
    type: 'pageview',
    path: pathname.slice(0, MAX_PATH_LENGTH),
    landing: isLanding,
    ...(isLanding ? { ref: landing.ref } : {}),
    utm: landing.utm,
    ads: landing.ads,
  });
}

export function trackLead() {
  if (typeof window === 'undefined') return;
  const pathname = window.location.pathname;
  if (!canTrack(pathname)) return;

  const context = landing || currentLandingContext();
  send({
    type: 'lead',
    path: pathname.slice(0, MAX_PATH_LENGTH),
    landingPath: context.landingPath,
    ref: context.ref,
    utm: context.utm,
    ads: context.ads,
  });
}

function send(payload) {
  try {
    fetch(ENDPOINT, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload),
    }).catch(() => {});
  } catch { /* statistiken får aldrig påverka sidan */ }
}
